// ==============================================
// /dashboard/library → /library
// ==============================================
//
// The Navigation Library is now the PassageWiki app entered through the
// MyPolaris door, served by a Worker route at /library (one codebase, two
// doors — 2026-09-11). This keeps every address that ever pointed at the old
// page working:
//
//   /dashboard/library                  → /library
//   /dashboard/library?lib=<id>         → /library?collection=<id>   (the
//                                         collection emails sent before the
//                                         move, and the admin reports queue)
//
// A real page load, not a router navigate: /library is a different app on this
// host. `replace` so Back does not bounce between the two.
//
// The old page itself is still reachable at /dashboard/library/classic while we
// are sure of the new one; that fallback and this file go together.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function NavigationLibraryRedirect() {
  const { search } = useLocation();

  useEffect(() => {
    const from = new URLSearchParams(search);
    const to = new URLSearchParams();
    const lib = from.get('lib');
    if (lib) to.set('collection', lib);
    const qs = to.toString();
    window.location.replace(`/library${qs ? `?${qs}` : ''}`);
  }, [search]);

  return (
    <div className="p-8 text-center text-slate-400">
      Opening the Navigation Library…
      <div className="mt-2 text-sm">
        If nothing happens, <a href="/library" className="text-amber-300 underline">open it here</a>.
      </div>
    </div>
  );
}

export default NavigationLibraryRedirect;
